import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'core/libs/router';

import { PageIndent } from 'core/components/Wrappers';
import Page from 'core/components/Page';
import H1 from 'core/components/H1';
import Link from 'core/components/Link';
import MailingRules from './MailingRules';
import TermsOfUse from './TermsOfUse';
import Privacy from './Privacy';
import RulesOfUse from './RulesOfUse';


/**
 * @author Aminev Ramil <r.aminev@rambler-co.ru>
 */

function LegalPage(props) {
  const {
    match: {
      params: {
        level2,
      },
    },
    description,
    mailingRulesContent,
    privacyContent,
    termsOfUseContent,
    rulesOfUseContent,
  } = props;

  const descriptionProp = description[level2];

  let title;
  let element;

  switch (level2) {
    case 'mailing-rules':
      title = 'Условия рассылок';
      element = (
        <MailingRules
          title={title}
          content={mailingRulesContent}
        />
      );
      break;
    case 'terms-of-use':
      title = 'Условия использования';
      element = (
        <TermsOfUse
          title={title}
          content={termsOfUseContent}
        />
      );
      break;
    case 'privacy':
      title = 'Политика конфиденциальности';
      element = (
        <Privacy
          title={title}
          content={privacyContent}
        />
      );
      break;
    case 'terms-of-use-2':
      title = 'Правила использования';
      element = (
        <RulesOfUse
          title={title}
          content={rulesOfUseContent}
        />
      );
      break;
    default:
      title = 'Правовая информация';
      element = (
        <Fragment>
          <H1>{title}</H1>
          <p>
            <Link to={'/legal/terms-of-use'}>Условия использования</Link>
          </p>
          <p>
            <Link to={'/legal/mailing-rules'}>Условия рассылок</Link>
          </p>
          <p>
            <Link to={'/legal/privacy'}>Политика конфиденциальности</Link>
          </p>
          <p>
            <Link to={'/legal/terms-of-use-2'}>Правила использования</Link>
          </p>
        </Fragment>
      );
  }

  return (
    <Page description={descriptionProp} title={title}>
      <PageIndent>
        {element}
      </PageIndent>
    </Page>
  );
}

LegalPage.propTypes = {
  /**
   * Кастомный description для LegalPage-урлов
   */
  description: PropTypes.shape({
    'mailing-rules': PropTypes.string,
    'terms-of-use': PropTypes.string,
    'privacy': PropTypes.string,
    'terms-of-use-2': PropTypes.string,
  }),
  mailingRulesContent: PropTypes.element,
  privacyContent: PropTypes.element,
  termsOfUseContent: PropTypes.element,
  rulesOfUseContent: PropTypes.element,
  /** @ignore */
  match: PropTypes.shape({
    params: PropTypes.shape({
      level2: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

LegalPage.defaultProps = {
  description: {},
};

const LegalPageWithHOCs = withRouter(LegalPage);
LegalPageWithHOCs.displayName = 'LegalPage';

export { LegalPage as StorybookComponent };
export default LegalPageWithHOCs;
